<script>
	export let result;
</script>

<style>
	.search-result-item {
		padding: 1rem 0;
	}
	.search-result-item:not(:nth-child(-n+2)) {
		border-top: 1px #e5e3e4 solid;
	}
	.header-link {
		font-weight: 800;
	}
</style>

{#if result && result.title && result.description}
<div class="search-result-item">
	<p class="item-header">
		<a class="header-link" href="{result.url}" >{result.title.replace(/"/g,'')}</a>
	</p>
	<p class="description">{result.description !== 'null' ? result.description: ''}</p>
</div>
{/if}
